module.exports = __webpack_public_path__ + "static/PhoneCallToAction-b909301d6be4abfba896caa8fd1442d5.png";